// extracted by mini-css-extract-plugin
export default {"rating":"OA-z","numberOfStars":"PA-z","count":"QA-z","barGraphSpacing":"RA-z","barGraph":"SA-z"};